<script>

import {defineComponent} from "vue";
import DefaultBox from "../../../slots/DefaultBox.vue";
import GrayText from "../../../small_components/GrayText.vue";
import SmallTitle from "../../../small_components/SmallTitle.vue";
import RouterLinkTo from "../../../small_components/RouterLinkTo.vue";
import Loader from "../../../small_components/Loader.vue";
import DefaultTitle from "../../../small_components/DefaultTitle.vue";

export default defineComponent({
  name: "NewUserCard",
  components: {DefaultTitle, Loader, RouterLinkTo, SmallTitle, GrayText, DefaultBox}
})
</script>

<template>
  <div class="row">
    <div class="col-md-7 col-12 mt-20">
      <default-box>
        <div class="d-flex align-items-center">
          <small-title
              class="flex-grow-1"
              no_margin
              :text="$t('main.hello')"/>
        </div>
        <hr/>
        <div class="d-flex align-items-center">
          <div>
            <default-title :h_tag="'h3'">{{ $t('main.new_user_message') }}</default-title>
          </div>
        </div>
      </default-box>
    </div>
  </div>
</template>

<style scoped>

</style>